import Vue from "vue";
import { vuexfireMutations } from "vuexfire";
import Vuex from "vuex";
import { db, storage } from "@/config/firebaseInit";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    kiosk: null,
    services: [],
    servicesSorted: {
      activity: [],
      dining: [],
    },
  },
  getters: {
    getKiosk: (state) => {
      return state.kiosk;
    },
    getServicesSorted: (state) => {
      return state.servicesSorted;
    },
    getServices: (state) => {
      let serviceObj = {};
      state.services.forEach((s) => {
        serviceObj[s.id] = s;
      });
      return serviceObj;
    },
    getContractors: (state) => (area, service) => {
      return state.contractors.filter(
        (c) => c.activity_types[area] && c.services[service]
      );
    },
  },
  mutations: {
    ...vuexfireMutations,
    setKiosk(state, kiosk) {
      state.kiosk = Object.assign({}, kiosk);
      state.kiosk.id = kiosk.id;
    },
    async sortServices(state, sorted) {
      state.servicesSorted = sorted;
    },
  },
  actions: {
    bindServicesRef: (context) => {
      let children = {};
      return db
        .collection("preset_user_menus")
        .doc("service_menu")
        .collection("services")
        .onSnapshot(async (querySnapshot) => {
          context.state.services = querySnapshot.docs.map((s) =>
            Object.assign({ id: s.id }, s.data())
          );
          let serviceObj = {
            Activity: [],
            Dining: [],
          };

          for (let i = 0; i < context.state.services.length; i++) {
            let s = context.state.services[i];
            if (s.parent_category) {
              if (!children[s.parent_category]) {
                children[s.parent_category] = [s];
              } else {
                children[s.parent_category].push(s);
              }
            }
            let url = await storage
              .ref(`services/${s.slug}.png`)
              .getDownloadURL();
            s.icon = url;

            if (s.activity_types.activity) {
              serviceObj.Activity.push(s);
            }
            if (s.activity_types.dining) {
              serviceObj.Dining.push(s);
            }
          }
          serviceObj.children = children;
          context.state.servicesSorted = serviceObj;
        });
    },
  },
});
